import { createTheme, type Shadows } from '@mui/material';

const createShadow = (px: number) => {
  return `0 0 ${px}px 0 rgba(53,64,82,.07)`;
};

const shadows: Shadows = [
  'none',
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
];

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: '#3e52ff',
    },
    secondary: {
      main: '#ff4081',
    },
  },
  typography: {
    fontFamily: ['Noto Sans JP', 'sans-serif'].join(','),
    fontSize: 14,
    body1: {
      fontSize: 14,
    },
  },
  shadows,
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#f1f4fa',
          color: '#1c1b1f',
          '.MuiIconButton-root': {
            color: '#1c1b1f',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#101224',
          color: '#ffffff',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          border: 'solid 1px #C6C6C5',
          borderRadius: 8,
          position: 'relative',
          '&::after': {
            content: '""',
            display: 'block',
            height: 16,
            backgroundColor: '#ECECEC',
            borderTop: '1px solid #C6C6C5',
            position: 'sticky',
            bottom: 0,
            left: 0,
            width: '100%',
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          '.MuiTableCell-body': {
            borderBottom: '1px solid #C6C6C5',
          },
          '.MuiTableRow-root': {
            '&:last-of-type': {
              '.MuiTableCell-body': {
                borderBottom: 'none',
              },
            },
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          th: {
            height: 36,
            backgroundColor: '#ececec',
            paddingTop: 10,
            paddingBottom: 10,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          textTransform: 'none',
          '&.MuiButton-sizeSmall': {
            padding: '5px 20px',
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: '#C9D4F5',
          fontSize: 16,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          '.MuiDialogTitle-root + &': {
            paddingTop: 24,
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: 24,
          paddingTop: 0,
          '>:not(style)~:not(style)': {
            marginLeft: 24,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 14,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 28,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 8,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-notchedOutline': {
            borderRadius: 4,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-notchedOutline': {
            borderRadius: 4,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-outlined': {
            '&.MuiChip-colorSuccess': {
              borderColor: '#00BA77',
              color: '#00BA77',
              backgroundColor: '#E6FFFA',
            },
            '&.MuiChip-colorError': {
              borderColor: '#FF4D4F',
              color: '#ff4d4f',
              backgroundColor: '#FFF1F0',
            },
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#8a99c7',
        },
      },
    },
  },
});

export default theme;
